export const DEFAULT_ACTION = '/DEFAULT_ACTION';
export const LOCK_UNLOCK_WALLET_SUCCESS = '/LOCK_UNLOCK_WALLET_SUCCESS';



// WEBPACK FOOTER //
// client/containers/YscWalletLockUnlock/constants.js